import * as yup from 'yup';

export const formSchema = yup.object().shape({
  salary_frequency: yup.string().required('Required'),
  salary_amount: yup.number().required('Required'),
  accommodation_type: yup.string().required('Required'),
  accommodation_amount: yup.number().required('Required'),
  monthly_living_cost: yup.number().required('Required'),
});
